product.divisionCode = document.getElementById("division-code"),
product.productGroupCode = document.getElementById("group-code"),
product.offer = document.getElementById("offer")

const recommendations = {
  path: ()=>{
    const src = document.getElementById("cluster-recommendations-script").src;
    const path = src.substring(0,src.search("ux"));
    return path;
  },
  store: shasaStores[0],
  container: document.getElementById("ia-recommendations"),
  render(data) {
    for (const handle of data.items) {
      fetch(`https://shasa.com/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          if(product.available) {
            const container = document.createElement("div");
            const id = `cluster-card-${product.id}`;
            container.id = id;
            recommendations.container.appendChild(container);
            new Card(product.id, id, "cluster");
          }
        })
    }
  },
  init: ()=> {
    const group = product.productGroupCode.value.toLowerCase().replace(" ", "");
    const cluster = recommendations.store.cluster;
    const offer = product.offer.value;
    let name = group+cluster+offer;
    fetch(`${recommendations.path()}sr${cluster}.json`)
      .then(response => response.json()).then(res => {
        if (res[name]) {
          recommendations.render(res[name]);
        }
        else {
          name = product.divisionCode.value.startsWith("M") ? "top_ventasman" : "top_ventaswoman";
          fetch(recommendations.path()+"srtop_ventas.json")
            .then(response => response.json()).then(res => {
              recommendations.render(res[name]);
            });
        }
      });
  }
}
recommendations.init();